var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.621 7.915a380.734 380.734 0 0 1 4.666-2.01c2.221-.923 2.683-1.084 2.984-1.089a.526.526 0 0 1 .31.093.337.337 0 0 1 .114.217c.01.062.024.204.013.315-.12 1.265-.641 4.334-.906 5.751-.112.6-.333.8-.547.82-.465.043-.817-.307-1.267-.602-.704-.461-1.102-.748-1.786-1.199-.79-.52-.277-.806.173-1.274.117-.122 2.164-1.984 2.204-2.153.005-.021.01-.1-.037-.142-.047-.041-.116-.027-.166-.016-.07.016-1.195.76-3.374 2.23-.32.22-.609.327-.868.321-.286-.006-.835-.161-1.243-.294-.501-.163-.9-.249-.865-.526.018-.144.216-.29.595-.442Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 15.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramDeposit);
export default __webpack_public_path__ + "static/media/telegramDeposit.9c20886d583edd69c8e8e3a6afc0b1c2.svg";
export { ForwardRef as ReactComponent };